import styled from "styled-components";
import * as theme from "@theme";

export const Wrapper = styled.div`
  opacity: 0;
  bottom: 0;
`;
